var map = {
	"./arts_crafts/ac_diy.svg": 82522,
	"./arts_crafts/ac_handmade_jewelry.svg": 40715,
	"./arts_crafts/ac_other_arts.svg": 77259,
	"./arts_crafts/ac_paintings_prints.svg": 52182,
	"./arts_crafts/ac_pottery_ceramics.svg": 62517,
	"./arts_crafts/ac_sculptures.svg": 19112,
	"./arts_crafts/ac_textile_arts.svg": 43660,
	"./arts_crafts/arts_crafts.svg": 4067,
	"./education_entertainment/education_entertainment.svg": 36651,
	"./education_entertainment/ee_board_games.svg": 96173,
	"./education_entertainment/ee_books_educational_tools.svg": 41667,
	"./education_entertainment/ee_gaming_virtual_reality.svg": 36941,
	"./education_entertainment/ee_movies_theatre.svg": 79552,
	"./education_entertainment/ee_music_sound.svg": 38088,
	"./education_entertainment/ee_online_learning_platforms_courses.svg": 89409,
	"./education_entertainment/ee_streaming.svg": 54265,
	"./education_entertainment/ee_travel_tourism.svg": 34665,
	"./energy_environment/energy_environment.svg": 57265,
	"./energy_environment/env_electric_alternative_fuel_vehicles.svg": 79375,
	"./energy_environment/env_energy_efficiency.svg": 41013,
	"./energy_environment/env_environmental_monitoring_consulting.svg": 9469,
	"./energy_environment/env_recycling_waste_management.svg": 81278,
	"./energy_environment/env_renewable_energy.svg": 48829,
	"./fashion_apparel/fa_accessories.svg": 98551,
	"./fashion_apparel/fa_casual_formal_clothing.svg": 87497,
	"./fashion_apparel/fa_footwear.svg": 74822,
	"./fashion_apparel/fa_jewelry.svg": 70587,
	"./fashion_apparel/fa_luxury_items.svg": 63013,
	"./fashion_apparel/fa_sports_activewear.svg": 21582,
	"./fashion_apparel/fa_sustainable_eco_friendly.svg": 54694,
	"./fashion_apparel/fa_vintage_clothing.svg": 34270,
	"./fashion_apparel/fa_watches.svg": 51332,
	"./fashion_apparel/fashion_apparel.svg": 37887,
	"./financial_professional_services/financial_professional_services.svg": 32323,
	"./financial_professional_services/fp_accounting_tax.svg": 85167,
	"./financial_professional_services/fp_banking_investment.svg": 67916,
	"./financial_professional_services/fp_business_solutions.svg": 3673,
	"./financial_professional_services/fp_insurance.svg": 9054,
	"./financial_professional_services/fp_legal_consulting.svg": 58296,
	"./food_drinks/fb_alcoholic_beverages.svg": 82071,
	"./food_drinks/fb_desserts_snacks.svg": 54103,
	"./food_drinks/fb_ethnic_cuisine.svg": 49000,
	"./food_drinks/fb_food_services.svg": 50825,
	"./food_drinks/fb_fresh_produce_groceries.svg": 86515,
	"./food_drinks/fb_health_focused_organic.svg": 40856,
	"./food_drinks/fb_non_alcoholic_beverages.svg": 81763,
	"./food_drinks/fb_packaged_processed_foods.svg": 65549,
	"./food_drinks/fb_ready_to_eat_frozen_meals.svg": 51726,
	"./food_drinks/fb_street_food.svg": 16054,
	"./food_drinks/food_drinks.svg": 88815,
	"./health_wellness/health_wellness.svg": 70723,
	"./health_wellness/hw_fitness_exercise.svg": 52740,
	"./health_wellness/hw_health_services.svg": 6266,
	"./health_wellness/hw_nutritional_supplements_vitamins.svg": 87521,
	"./health_wellness/hw_personal_care_hygiene.svg": 90679,
	"./health_wellness/hw_pharmaceuticals_medical_devices.svg": 43797,
	"./home_lifestyle/hl_bedding_linens.svg": 30622,
	"./home_lifestyle/hl_cleaning_products_services.svg": 93614,
	"./home_lifestyle/hl_furniture.svg": 27517,
	"./home_lifestyle/hl_gardening_outdoor.svg": 39543,
	"./home_lifestyle/hl_home_appliances.svg": 12455,
	"./home_lifestyle/hl_home_decor.svg": 78518,
	"./home_lifestyle/hl_kitchen_essentials.svg": 22329,
	"./home_lifestyle/hl_lighting_fixtures.svg": 24230,
	"./home_lifestyle/home_lifestyle.svg": 33739,
	"./industrial_construction/ic_construction_materials_supplies.svg": 51123,
	"./industrial_construction/ic_engineering_architectural_services.svg": 68309,
	"./industrial_construction/ic_heavy_machinery_tools.svg": 78937,
	"./industrial_construction/ic_industrial_automation_robotics.svg": 81496,
	"./industrial_construction/ic_safety_protective_equipment.svg": 9012,
	"./industrial_construction/industrial_construction.svg": 65483,
	"./others/others.svg": 72651,
	"./tech_gadgets/tech_gadgets.svg": 98781,
	"./tech_gadgets/tg_computing_it_solutions.svg": 95132,
	"./tech_gadgets/tg_consumer_electronics.svg": 12671,
	"./tech_gadgets/tg_gaming.svg": 16460,
	"./tech_gadgets/tg_industrial_automation_technology.svg": 78185,
	"./tech_gadgets/tg_internet_ai.svg": 73821,
	"./tech_gadgets/tg_other_technologies.svg": 75468,
	"./tech_gadgets/tg_smart_home_iot_devices.svg": 49689,
	"./tech_gadgets/tg_telecommunications.svg": 99636,
	"./transportation_mobility/tm_aviation_maritime_equipment.svg": 76044,
	"./transportation_mobility/tm_logistics_courier_services.svg": 33993,
	"./transportation_mobility/tm_personal_vehicles.svg": 46251,
	"./transportation_mobility/tm_public_shared_transportation.svg": 15263,
	"./transportation_mobility/tm_vehicle_maintenance_rental_services.svg": 83383,
	"./transportation_mobility/transportation_mobility.svg": 14931
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93623;